import absoluteUrl from 'next-absolute-url'

import ArticleDetail from 'containers/ArticleDetail'

import Layout from 'components/Layout'
import MetaTags from 'components/MetaTags'

import { getArticleByCodeApi } from 'services/article'
import { getCanonicalUrl } from 'lib/seo'

export default function Index({ canonical, data, slug }) {
  const metaTitle = data?.title
  const metaDescription = data?.shortDescription
  const metaImage = data?.thumbnailImage?.[0]?.url
  const publishedTime = data?.createdAt
  const modifiedTime = data?.updatedAt
  const canonicalUrl = getCanonicalUrl(canonical)

  return (
    <>
      <MetaTags
        title={metaTitle}
        description={metaDescription}
        image={metaImage}
        ogType="article"
        publishedTime={publishedTime}
        modifiedTime={modifiedTime}
        section={metaTitle}
        pathUrl={canonical}
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'BlogPosting',
          headline: metaTitle,
          description: metaDescription,
          image: metaImage ? [metaImage] : undefined,
          datePublished: publishedTime,
          dateModified: modifiedTime,
          mainEntityOfPage: canonicalUrl,
          publisher: {
            '@type': 'Organization',
            name: '24 FIX',
            logo: {
              '@type': 'ImageObject',
              url: getCanonicalUrl('/assets/images/24fix-black-logo.png'),
            },
          },
        }}
      />

      <Layout>
        <ArticleDetail data={data} slug={slug} />
      </Layout>
    </>
  )
}

export async function getServerSideProps(context) {
  const { req, res, query } = context
  const { origin } = absoluteUrl(req)
  const { slug, article_slug } = query

  res.setHeader('Cache-Control', 'public, s-maxage=60, stale-while-revalidate=59')

  const data = await getArticleByCodeApi(article_slug).then(res => res.data.data?.[0])

  if (!data) {
    return { notFound: true }
  }

  return {
    props: JSON.parse(
      JSON.stringify({
        canonical: `${origin}/blog/${slug}/${article_slug}`,
        data,
        slug,
      })
    ),
  }
}
